const ONE_MINUTE_MS = 60 * 1000;
const PACIFIC_TIME_ZONE = 'America/Los_Angeles';
const PACIFIC_TIME_GEOS = new Set(['US', 'CA']);
const getPart = (parts, type) => {
  var _parts$find;
  return ((_parts$find = parts.find(part => part.type === type)) == null ? void 0 : _parts$find.value) ?? '';
};
const formatDate = (date, locale, timeZone) => new Intl.DateTimeFormat(locale, {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  timeZone
}).format(date);
const getPacificTimeParts = date => new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: '2-digit',
  hourCycle: 'h12',
  timeZone: PACIFIC_TIME_ZONE
}).formatToParts(date);
const isPacificMidnight = date => {
  if (date % ONE_MINUTE_MS !== 0) {
    return false;
  }
  const parts = getPacificTimeParts(date);
  return getPart(parts, 'hour') === '12' && getPart(parts, 'minute') === '00' && getPart(parts, 'dayPeriod') === 'AM';
};
const formatPacificTime = date => {
  const parts = getPacificTimeParts(date);
  return `${getPart(parts, 'hour')}:${getPart(parts, 'minute')} ${getPart(parts, 'dayPeriod')} PT`;
};
const formatUtcTime = date => new Intl.DateTimeFormat('en-GB', {
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
  timeZone: 'UTC'
}).format(date);
export const formatSaleEndDateInTimeZone = _ref => {
  let {
    saleEndDate,
    geo,
    locale
  } = _ref;
  if (PACIFIC_TIME_GEOS.has(geo)) {
    const displayedEnd = isPacificMidnight(saleEndDate) ? saleEndDate - ONE_MINUTE_MS : saleEndDate;
    return `${formatDate(displayedEnd, locale, PACIFIC_TIME_ZONE)} (${formatPacificTime(displayedEnd)})`;
  }
  return `${formatDate(saleEndDate, locale, 'UTC')} (${formatUtcTime(saleEndDate)} GMT)`;
};
//# sourceMappingURL=formatSaleEndDateInTimeZone.js.map